import React, { useMemo } from 'react'
import { ModalTitle, OverlayTrigger, Popover } from 'react-bootstrap'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import InfoIcon from '../assets/img/svg/info-icon.svg'
const CustomModal = ({ isOpen, toggle, children, title, size = 'md', isTitle = true, isOverlay, popupMessage = '' }) => {
  const popoverClick = useMemo(
    () => (
      <Popover id="popover-trigger-click">
        <div className="popover-content-custom p-3">
          <div className="popover-description mb-0">{popupMessage}</div>
        </div>
      </Popover>
    ),
    []
  )

  return (
    <Modal size={size} centered isOpen={isOpen} toggle={toggle}>
      {isTitle && (
        <ModalHeader toggle={toggle}>
          <ModalTitle className={`fw-600 ${isOverlay ? 'modal-header-with-tooltip' : ''}`}>{title}</ModalTitle>
          {isOverlay && (
            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={popoverClick} rootClose>
              <img src={InfoIcon} alt="Info" width={23} height={23} />
            </OverlayTrigger>
          )}
        </ModalHeader>
      )}
      <ModalBody>{children}</ModalBody>
    </Modal>
  )
}

export default CustomModal
